import { ISearchResponse } from 'apiConnector/blotters';
import type { Collection } from 'state/utils/types';

import type { ProductFilter } from '../common/blotter.model';

export interface Filters {
  product: ProductFilter;
  searchedText: string;
}
export interface DailyBlotterQuote {
  canReprice: boolean;

  rfqId: string;
  externalQuoteId: string;
  instrumentContractName: string;
  instrumentName: string;
  maturityDate: string;
  notionalAmount: number;
  pricerRfqId: string;
  productId: string;
  productSubtype: string;
  productType: string;
  quoteDate: string;
  salesCounterpart: string;
  solve: string;
  solveResult: number;
  underlyings: string;
  wrapper: string;
} // WIP
export type DailyBlotterQuotes = Collection<DailyBlotterQuote>;

export interface Infos extends PageInfo {
  filters: Filters;
  isFetchingQuotes: boolean;
  quotesId?: string[];
  selectedQuoteId?: string;
  instrumentName?: string;
  instrumentContractName?: string;
  wrapper?: string;
  canRepriceSelectedQuoteInNewStaticScreen?: boolean;
}
export type PageInfo = Readonly<{
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}>;

export type DailyBlotterState = Readonly<{
  infos: Infos;
  quotes: DailyBlotterQuotes;
  columnDefinitions: columnDefinitions;
}>;

export type DailyBlotterResponse = ISearchResponse<DailyBlotterQuote>;

export const initialDailyBlotterFilters: Filters = { searchedText: '', product: 'allProducts' };

export const initialDailyBlotterPageInfo: PageInfo = {
  page: 1,
  size: 10,
  totalElements: 0,
  totalPages: 0,
};
export const initialDailyBlotterInfosState: Infos = {
  isFetchingQuotes: false,
  filters: initialDailyBlotterFilters,
  page: initialDailyBlotterPageInfo.page,
  size: initialDailyBlotterPageInfo.size,
  totalElements: initialDailyBlotterPageInfo.totalElements,
  totalPages: initialDailyBlotterPageInfo.totalPages,
};

export const initialDailyBlotterState = (): DailyBlotterState => ({
  infos: initialDailyBlotterInfosState,
  quotes: {},
  columnDefinitions: { columns: [] },
});

// REPRICE

type RepriceNames = 'RepruceInNewStaticScreen';

export interface RepriceAction {
  name: RepriceNames;
  disable: boolean;
}
export type RepriceActions = RepriceAction[];

// COLUMNS DEF

export type columns = any[];
export type columnDefinitions = Readonly<{
  columns: columns;
}>;
export type columnDefinitionsData = Readonly<{ columnDefinitions: columns }>;
export type DailyBlotterColumns = Readonly<{ data: columnDefinitionsData }>;
